import DropDown from './drop-down';

class DropDownInput extends DropDown {
  constructor() {
    super();
    this.checkValue = this.checkValue.bind(this);
    this.handleKeyboardNavigation = this.handleKeyboardNavigation.bind(this);
    this.dropDownInput = null;
    this.currentFocusedIndex = -1;
    this.dropdownChange();
  }

  dropdownChange() {
    const button = this.querySelector('.recomended__filter');
    button.addEventListener('click', () => {
      const value = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!value));

      const dropdown = document.querySelector('.dropdown-menu__sortedBt');

      if (!value) {
        this.currentFocusedIndex = -1;
        this.setupKeyboardNavigation(dropdown);
      } else {
        this.resetHighlight();
      }

      this.trapFocus(dropdown);
    });
  }

  setupKeyboardNavigation(dropdown) {
    dropdown.removeEventListener('keydown', this.handleKeyboardNavigation);
    dropdown.addEventListener('keydown', this.handleKeyboardNavigation);
  }

  resetHighlight() {
    const inputs = Array.from(this.querySelectorAll('.js-drop-down-input'));
    inputs.forEach((input) => {
      const label = input.closest('label') || input.parentElement;
      if (label) {
        label.classList.remove('keyboard-focused');
      }
    });
    this.currentFocusedIndex = -1;
  }

  handleKeyboardNavigation(e) {
    const inputs = Array.from(this.querySelectorAll('.js-drop-down-input'));

    if (!inputs.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.currentFocusedIndex = (this.currentFocusedIndex + 1) % inputs.length;
      this.highlightOption(inputs, this.currentFocusedIndex);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.currentFocusedIndex = this.currentFocusedIndex <= 0 ? inputs.length - 1 : this.currentFocusedIndex - 1;
      this.highlightOption(inputs, this.currentFocusedIndex);
    } else if (e.key === 'Tab') {
      e.preventDefault();
      if (e.shiftKey) {
        this.currentFocusedIndex = this.currentFocusedIndex <= 0 ? inputs.length - 1 : this.currentFocusedIndex - 1;
      } else {
        this.currentFocusedIndex = (this.currentFocusedIndex + 1) % inputs.length;
      }
      this.highlightOption(inputs, this.currentFocusedIndex);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (this.currentFocusedIndex >= 0 && this.currentFocusedIndex < inputs.length) {
        const selectedInput = inputs[this.currentFocusedIndex];
        selectedInput.checked = true;
        selectedInput.dispatchEvent(new Event('change', { bubbles: true }));

        const button = this.querySelector('.recomended__filter');
        button.setAttribute('aria-expanded', 'false');
        this.resetHighlight();
        button.focus();
      } else {
        const block = this.querySelector('.dropdown-menu__sortedBt');
        block.setAttribute('data-open', 'true');
        block.classList.add('open');
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      const button = this.querySelector('.recomended__filter');
      button.setAttribute('aria-expanded', 'false');
      const block = this.querySelector('.dropdown-menu__sortedBt');
      block.setAttribute('data-open', 'false');
      block.classList.remove('open');

      this.resetHighlight();
      button.focus();
    }
  }

  highlightOption(inputs, index) {
    inputs.forEach((input, i) => {
      const label = input.closest('label') || input.parentElement;
      if (label) {
        label.classList.remove('keyboard-focused');
        if (i === index) {
          label.classList.add('keyboard-focused');
          label.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      }
    });

    inputs[index].focus();
  }

  trapFocus(dialog) {
    const focusableElements = dialog.querySelectorAll('a, button, select, textarea, [tabindex]:not([tabindex="-1"])');

    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            e.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            e.preventDefault();
            firstFocusableElement.focus();
          }
        }
        if (document.activeElement === lastFocusableElement) {
          e.preventDefault();
          firstFocusableElement.focus();
        }
      }
    });
  }

  checkValue() {
    this.dropDownInput = this.querySelectorAll('.js-drop-down-input');
    this.sortTitle = this.querySelector('.sort_method');

    if (!this.dropDownInput.length) return;

    this.dropDownInput.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        this.dropDownInput.forEach((input) => {
          if (input !== checkbox) {
            input.removeAttribute('checked');
          }
        });

        if (checkbox.checked) {
          if (this.sortTitle) {
            this.sortTitle.textContent = checkbox.getAttribute('data-name') || checkbox.value;
          }
          checkbox.setAttribute('checked', 'checked');
        } else {
          checkbox.removeAttribute('checked');
        }
      });
    });
  }

  connectedCallback() {
    super.connectedCallback();
    this.checkValue();
  }
}

const init = () => {
  if (!customElements.get('custom-dropdown-input')) {
    customElements.define('custom-dropdown-input', DropDownInput);
  }
};

init();
